 export let SAVE_FORM = "SAVE_FORM";

 export let GET_FORMS = "GET_FORMS";

 export let DELETE_FORM = "DELETE_FORM";

 export let FORM_UPDATE = "FORM_UPDATE";


 export let SAVE_SIGNUP = "SAVE_SIGNUP";

 export let GET_AUTH = "GET_AUTH";        // login


 export let DUPERR_MSG = "DUPERR_MSG";

export let MSG_LOGIN = "MSG_LOGIN";

export let LOGOUT = "LOGOUT";

export let ISTOKEN_OK = "ISTOKEN_OK";

export let MSG_LOGINS = "MSG_LOGINS";


export let FORG_PASS = "FORG_PASS";

export let FORG_PASSERR = "FORG_PASSERR";



export let UPDATEPASS_MSG = "UPDATEPASS_MSG";


export let CLEAR_STATE = "CLEAR_STATE";

export let ISTOKEN_OKTOEDIT = "ISTOKEN_OKTOEDIT";



// export let LOGIN_DETAIL = "LOGIN_DETAIL"
// export let LOGIN_SUCCESS = 'LOGIN_SUCCESS'
// export let LOGIN_FAILED = 'LOGIN_FAILED'
// export let TOKEN = 'TOKEN'
// export let PROFILE = 'PROFILE'
// export let LOGOUT = "LOGOUT"

// export let PASSWORD_CONFIRMED = "PASSWORD_CONFIRMED"
// export let PASSWORD_CONFIRMED_ERROR = "PASSWORD_CONFIRMED_ERROR"



// export let DELETE_TOP_STORY = "DELETE_TOP_STORY"
// export let CREATE_TOP_STORY = "CREATE_TOP_STORY"
// export let EDIT_TOP_STORY = "EDIT_TOP_STORY"

// export let DELETE_ARTICLE = "DELETE_ARTICLE"
// export let CREATE_ARTICLE = "CREATE_ARTICLE"
// export let EDIT_ARTICLE = "EDIT_ARTICLE"

// export let DELETE_EDITOR = "DELETE_EDITOR"
// export let CREATE_EDITOR = "CREATE_EDITOR"
// export let EDIT_EDITOR = "EDIT_EDITOR"

// export let DELETE_CATEGORY = "DELETE_CATEGORY"
// export let CREATE_CATEGORY = "CREATE_CATEGORY"
// export let EDIT_CATEGORY = "EDIT_CATEGORY"

// export let DELETE_BANNER = "DELETE_BANNER"
// export let CREATE_BANNER = "CREATE_BANNER"
// export let EDIT_BANNER = "EDIT_BANNER"

// export let DELETE_VIDEO_ARTICLE = "DELETE_VIDEO_ARTICLE"
// export let CREATE_VIDEO_ARTICLE = "CREATE_VIDEO_ARTICLE"
// export let EDIT_VIDEO_ARTICLE = "EDIT_VIDEO_ARTICLE"

// export let PASSWORD_UPDATED = "PASSWORD_UPDATED"
// export let PASSWORD_UPDATED_ERROR = "PASSWORD_UPDATED_ERROR"



// export let UPDATE_ATICLE_SECCUSS = "UPDATE_ATICLE_SECCUSS"
// export let UPDATE_STORY_SECCUSS = "UPDATE_STORY_SECCUSS"
// export let UPDATE_VIDEO_SECCUSS = "UPDATE_VIDEO_SECCUSS"
// export let UPDATE_BANNER_SECCUSS = "UPDATE_BANNER_SECCUSS"


// export let DELETE_HEADER = "DELETE_HEADER"
// export let CREATE_HEADER = "CREATE_HEADER"
// export let EDIT_HEADER = "EDIT_HEADER"

// export let DELETE_FOOTER = "DELETE_FOOTER"
// export let CREATE_FOOTER = "CREATE_FOOTER"
// export let EDIT_FOOTER = "EDIT_FOOTER"


// export let DELETE_SIDEBAR = "DELETE_SIDEBAR"
// export let CREATE_SIDEBAR = "CREATE_SIDEBAR"
// export let EDIT_SIDEBAR = "EDIT_SIDEBAR"

// export let CREATE_MAGZINE = "CREATE_MAGZINE"




// export let TEAM_UPDATE = "TEAM_UPDATE"
// export let GALLERY_UPDATE = "GALLERY_UPDATE"



